import { render, staticRenderFns } from "./explain.view.vue?vue&type=template&id=1bccdc14&scoped=true"
import script from "./explain.view.vue?vue&type=script&lang=ts"
export * from "./explain.view.vue?vue&type=script&lang=ts"
import style0 from "./explain.view.vue?vue&type=style&index=0&id=1bccdc14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bccdc14",
  null
  
)

export default component.exports